<!-- A side by side toggleable yes/no button -->
<template>
    <q-btn-toggle
        :model-value="modelValue"
        :options="options"
        :toggle-color="toggleColor"
        :clearable="!noClear"
        no-caps
        :disable="disabled"
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    modelValue: Boolean,
    noClear: Boolean, // Prevent clearing / setting of nullable value?
    yes: {
        type: String,
        default: 'yes',
    },

    no: {
        type: String,
        default: 'no',
    },
    invertColor: Boolean,
    disabled: Boolean,
})

defineEmits(['update:modelValue'])

const options = [
    {
        label: trans(props.yes),
        icon: props.invertColor ? 'priority_high': 'done',
        value: true,
    },
    {
        label: trans(props.no),
        icon: 'clear',
        value: false,
    },
]

const toggleColor = computed(() => {
    if (props.invertColor) {
        return props.modelValue ? 'negative' : 'positive'
    } else {
        return props.modelValue ? 'positive' : 'negative'
    }
})
</script>
